export const sliderItems=[
    {
        id:1,
        img:"https://cdn.pixabay.com/photo/2016/11/14/03/11/geisha-1822467_960_720.jpg",
        title:"SUMMER SALE",
        desc:"STYLE  CHIC  SUN. SURPRISE GIFTS",
        bg:"f5fafd"
    },
    {
        id:2,
        img:"https://cdn.pixabay.com/photo/2020/12/13/16/37/woman-5828786_960_720.jpg",
        title:"AUTUMN SALE",
        desc:"STYLE  CHIC  LOVE. SURPRISE GIFTS",
        bg:"fcf1ed"
    },
    {
        id:3,
        img:"https://cdn.pixabay.com/photo/2016/11/29/05/44/woman-1867608_960_720.jpg",
        title:"WINTER SALE",
        desc:"STYLE  CHIC  SNOW. SURPRISE GIFTS",
        bg:"fbf0f4"
    },
    {
        id:4,
        img:"https://cdn.pixabay.com/photo/2020/02/19/19/11/clothes-4862980_960_720.jpg",
        title:"SUMMER SALE",
        desc:"STYLE  CHIC  SUN. SURPRISE GIFTS",
        bg:"f5fafd"
    },
    {
        id:5,
        img:"https://cdn.pixabay.com/photo/2014/04/08/14/51/man-319286_960_720.jpg",
        title:"AUTUMN SALE",
        desc:"STYLE  CHIC  LOVE. SURPRISE GIFTS",
        bg:"fcf1ed"
    },
    {
        id:6,
        img:"https://cdn.pixabay.com/photo/2013/07/13/11/32/tuxedo-158342_960_720.png",
        title:"WINTER SALE",
        desc:"STYLE  CHIC  SNOW. SURPRISE GIFTS",
        bg:"fbf0f4"
    },
]

export const categories=[
    {
        id:1,
        img:"https://cdn.pixabay.com/photo/2017/05/26/07/37/shirt-2345417_960_720.jpg",
        title:"SHIRT STYLE",
        category:"man"
    },
    {
        id:2,
        img:"https://cdn.pixabay.com/photo/2020/05/19/19/48/cat-5192430_960_720.png",
        title:"PYJAMAS",
        category:"woman"
    },
    {
        id:3,
        img:"https://cdn.pixabay.com/photo/2016/11/19/11/33/footwear-1838767_960_720.jpg",
        title:"SHOES",
        category:"man"
    },
    {
        id:4,
        img:"https://cdn.pixabay.com/photo/2016/03/27/22/16/fashion-1284496_1280.jpg",
        title:"SHOES",
        category:"woman"
    },
    {
        id:5,
        img:"https://cdn.pixabay.com/photo/2016/12/09/11/33/smartphone-1894723_1280.jpg",
        title:"PHONE",
        category:"electronic"
    },
    {
        id:6,
        img:"https://cdn.pixabay.com/photo/2020/03/06/19/33/brush-4908005_1280.jpg",
        title:"COSMETIC",
        category:"cosmatic"
    },
    {
        id:7,
        img:"https://cdn.pixabay.com/photo/2017/08/02/01/01/living-room-2569325_1280.jpg",
        title:"HOME",
        category:"home"
    },
    {
        id:8,
        img:"https://cdn.pixabay.com/photo/2012/02/29/12/11/girl-18918_1280.jpg",
        title:"BABY",
        category:"baby"
    },
    {
        id:9,
        img:"https://cdn.pixabay.com/photo/2017/07/02/19/24/dumbbells-2465478_1280.jpg",
        title:"SPOR",
        category:"spor"
    },
    {
        id:10,
        img:"https://cdn.pixabay.com/photo/2015/12/09/17/11/vegetables-1085063_1280.jpg",
        title:"FOOD",
        category:"food"
    },
    {
        id:11,
        img:"https://cdn.pixabay.com/photo/2023/04/24/03/16/camping-7947056_1280.jpg",
        title:"CAMPING",
        category:"camping"
    },
    {
        id:12,
        img:"https://cdn.pixabay.com/photo/2020/06/09/03/08/craft-5276736_1280.jpg",
        title:"HOBBY",
        category:"hobby"
    },
   

]

